import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Label = styled('span')`
    margin-left: 14px;
    text-transform: none;
    font-size: 12px;

    color: ${theme.palette.error.main};
    display: inline-flex;
    overflow: hidden;
`;
